import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useObjectStoreTemplatesStore } from "@/stores/objectStoreTemplatesStore";
import TemplateSummaryPopover from "./TemplateSummaryPopover.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TemplateSummarySpan',
    props: {
        templateId: null,
        templateVersion: null
    },
    setup(__props) {
        const props = __props;
        const objectStoreTemplatesStore = useObjectStoreTemplatesStore();
        const template = computed(() => objectStoreTemplatesStore.getTemplate(props.templateId, props.templateVersion));
        const target = `template-summary-span-${crypto.randomUUID()}`;
        objectStoreTemplatesStore.ensureTemplates();
        return { __sfc: true, objectStoreTemplatesStore, props, template, target, TemplateSummaryPopover };
    }
});
